import { Directive } from 'vue';
import { debounce as _debounce } from 'lodash-es';

/**
 * 按钮防抖
 */
const debounce: Directive = {
  mounted(el, binding) {
    const { value, arg } = binding;
    el.addEventListener(
      arg,
      _debounce(value, 1000, {
        leading: true,
        trailing: false
      })
    );
  }
};

export default debounce;
